import type { RootState } from '@/root-store';

const getJourneys = (state: RootState) => state.journeys.journeys;

const getJourney = (state: RootState) => state.journeys.journey;

export { getJourneys, getJourney };
